import Intercom from "@intercom/messenger-js-sdk";
import { useAuth } from "~/modules/auth/use-auth";
import { useTenant } from "~/modules/tenant/use-tenant";
import { clientEnv } from ".env/.browser";

const getUserType = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // If there are more than two parts in the hostname, it has a subdomain
  if (parts.length > 2) {
    return "lite";
  }

  // Otherwise, consider it as a full user
  return "full";
};

const getBaseURL = () => {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.hostname}`;
};

export const useIntercom = (props?: { verticalPadding?: number }) => {
  const { verticalPadding = 0 } = props || {};
  const { user } = useAuth();
  const tenant = useTenant();

  if (typeof document === "undefined" || !clientEnv.CLIENT_INTERCOM_APP_ID) return;

  if (!user?.userId || !user?.email) {
    Intercom({
      app_id: clientEnv.CLIENT_INTERCOM_APP_ID,
    });
    return;
  }

  Intercom({
    app_id: clientEnv.CLIENT_INTERCOM_APP_ID,
    user_id: user.userId,
    name: user.fullName || "",
    email: user.email,

    company: {
      company_id: tenant.slug,
      name: tenant.slug,
      plan: getUserType(),
      website: getBaseURL(),
    },
    vertical_padding: verticalPadding,
  });
};
